// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".live[data-v-61672d64] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.card[data-v-61672d64] {\n  padding: 2rem 0 0;\n}\n.card h1[data-v-61672d64] {\n  margin-bottom: 0;\n}\n.card .container[data-v-61672d64] {\n  margin: 0 2rem;\n}", ""]);
// Exports
module.exports = exports;
